import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addLead, addUserLead, getLeadSource, getLeadStatus, getLeadStatusApi, getLeadType, updateLead, updateUserLead } from "../../services/leads";
import { Calendar } from "primereact/calendar";
import { getUserData } from "../../utils/localStorage";
import { getBankAccount, getPreferredLanguage, getStateWiseCities, getUser } from "../../services/userMasterUser";

export default function SuperTelecallerLeadFormCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const rowData = state?.rowData || null;
  const products = state?.listState?.products || [];
  const first = state?.listState?.first || 0;
  const rows = state?.listState?.rows || 20;

  const [stateCitiesList, setStateCitiesList] = useState([])

  const { userProfileData } = getUserData();
  const [bankDetailsList, setBankDetailsList] = useState([])

  const [leadTypeList, setLeadTypeList] = useState([])

  const [typeOfLead, setTypeOfLead] = useState(rowData?.lead?.id ? rowData?.lead?.typeOfLead : "Loan");
  // const [leadStatusList, setLeadStatusList] = useState([]);
  const [leadSourceList, setLeadSourceList] = useState([]);
  const [selectedTelecallerId, setSelectedTelecallerId] = useState("");

  const [stateCityList, setStateCityList] = useState({});

  const [preferredLanguageList, setPreferredLanguageList] = useState([])


  let today = new Date();
  let month = today.getMonth();
  let year = today.getFullYear();
  let prevMonth = month === 0 ? 11 : month - 1;
  let prevYear = prevMonth === 11 ? year - 1 : year;
  // let nextMonth = month === 11 ? 0 : month + 1;
  // let nextYear = nextMonth === 0 ? year + 1 : year;
  let nextYear = year + 10;

  let minDate = new Date();

  // minDate.setMonth(prevMonth);
  // minDate.setFullYear(prevYear);

  let maxDate = new Date();

  // maxDate.setMonth(nextMonth);
  maxDate.setFullYear(nextYear);


  const typeOfLeadList = [
    { label: "Loan Type Lead", value: "loan_type_lead" },
    { label: "Project Report, Tev Study Pitch Deck", value: "project_report_tev_study_pitch_deck" },
    { label: "Course", value: "course" },
    { label: "Software", value: "software" },
    { label: "Subsidy", value: "subsidy" },
    { label: "Business Partner", value: "business_partner" },
    { label: "Customer Care Any Other Query", value: "customer_care_telecaller_any_other_query" },
    { label: "Banker Directory", value: "banker_directory" },
    { label: "Nivesh4u", value: "nivesh4u" },
    { label: "CFO MSME", value: "cfo_msme" },
  ];

  const statusOfBusinessList = [
    { label: "New", value: "New" },
    { label: "Existing", value: "Existing" },
  ];

  const TypeOfCustomerData = [
    { label: "Salaried", value: "Salaried" },
    { label: "Self Employed", value: "Self Employed" },
    { label: "Business Partner", value: "Business Partner" },
  ];

  const TypeOfCustomerData2 = [
    { label: "Self Employed", value: "Self Employed" },
    { label: "Business Partner", value: "Business Partner" },
  ];

  const TypeOfCustomerData3 = [
    { label: "Salaried", value: "Salaried" },
    { label: "Self Employed", value: "Self Employed" },
  ];

  const TypeOfCustomerData4 = [
    { label: "Self Employed", value: "Self Employed" },
  ];

  const LevelOfCustomerData = [
    { label: "High Profile", value: "High Profile" },
    { label: "Medium Profile", value: "Medium Profile" },
    { label: "Low Profile", value: "Low Profile" },
  ];

  const ActionOnLeadData = [
    { label: "In Process", value: "In Process" },
    { label: "Prelogin", value: "Prelogin" },
    { label: "Hold For Follow Up After Sometime", value: "Hold For Follow Up After Sometime" },
    { label: "Call Not Pick Up", value: "Call Not Pick Up" },
    { label: "Not Interested", value: "Not Interested" },
    { label: "Not Doable", value: "Not Doable" },
  ];

  const ActionOnLeadData2 = [
    { label: "In Process", value: "In Process" },
    { label: "Work Assign To Operation", value: "Work Assign To Operation" },
    { label: "Work Include", value: "Work Include" },
    { label: "Hold For Follow Up After Sometime", value: "Hold For Follow Up After Sometime" },
    { label: "Call Not Pick Up", value: "Call Not Pick Up" },
    { label: "Not Interested", value: "Not Interested" },
    { label: "Not Doable", value: "Not Doable" },
  ];

  const TelecallerActionData = [
    { label: "In Process", value: "In Process" },
    { label: "Not Interested", value: "Not Interested" },
    { label: "Call Not Pick Up", value: "Call Not Pick Up" },
    { label: "Success", value: "Success" },
  ];

  const BackgroundData = [
    { label: "Ca", value: "Ca" },
    { label: "Cs", value: "Cs" },
    { label: "Icwa", value: "Icwa" },
    { label: "Financial Consultant", value: "Financial Consultant" },
    { label: "Bank Dsa", value: "Bank Dsa" },
    { label: "Bank Employees", value: "Bank Employees" },
    { label: "Insurance Advisor", value: "Insurance Advisor" },
    { label: "Invetsment Advisor", value: "Invetsment Advisor" },
    { label: "Machine Dealer / Manufacturer", value: "Machine Dealer / Manufacturer" },
    { label: "Property Dealer", value: "Property Dealer" },
    { label: "Subsidy Consultant", value: "Subsidy Consultant" },
    { label: "Tax Advisor", value: "Tax Advisor" },
    { label: "Tax Advocate", value: "Tax Advocate" },
    { label: "Accountant", value: "Accountant" },
    { label: "Cfo", value: "Cfo" },
    { label: "Other", value: "Other" },
  ]

  const StatusOfBusinessPartnerData = [
    { label: "Super Active", value: "Super Active" },
    { label: "Moderate", value: "Moderate" },
    { label: "Low Active", value: "Low Active" },
    { label: "Not Interested", value: "Not Interested" },

  ]

  const BankListData = [
    { label: "Bank1", value: "Bank1" },
    { label: "Bank2", value: "Bank2" },
  ]

  const NatureOfServiceData = [
    { label: "Share", value: "Share" },
    { label: "Mutual Fund", value: "Mutual Fund" },
    { label: "Bond", value: "Bond" },
    { label: "Fixed Deposit", value: "Fixed Deposit" },
    { label: "AIF", value: "AIF" },
    { label: "PMS Property", value: "PMS Property" },
    { label: "Bank1", value: "other" },
  ]

  const NatureOfServiceData2 = [
    { label: "Gst", value: "Gst" },
    { label: "Income Tax", value: "Income Tax" },
    { label: "Company Law", value: "Company Law" },
    { label: "Other", value: "Other" },
  ]

  const LeadStatus = [
    { label: "In Process", value: "In Process" },
    { label: "Call Not Pick Up", value: "Call Not Pick Up" },
    { label: "Not Interested", value: "Not Interested" },
    { label: "On Board", value: "On Board" },

  ]

  const cibilScoreListData = [
    { label: "Low (Below 600)", value: "Low (Below 600)" },
    { label: "Average (600 - 699)", value: "Average (600 - 699)" },
    { label: "Medium (700 - 749)", value: "Medium (700 - 749)" },
    { label: "Excellent (Above 750)", value: "Excellent (Above 750)" },
    { label: "I Don't Know", value: "I Don't Know" },
  ]

  // Common Fields
  const [commonInput, setCommonInput] = useState({
    name: rowData?.lead?.name || "",
    mobileNo: rowData?.lead?.mobileNo || "",
    source: rowData?.lead?.source || "",
    city: rowData?.lead?.city || "",
    pinCode: rowData?.lead?.pinCode || "",
    state: rowData?.lead?.state || "",
    address: rowData?.lead?.address || "",
    loanAmount: rowData?.lead?.amount || "",
    remarkCustomer: rowData?.lead?.queries || "",
    preferredLanguage: rowData?.lead?.preferredLanguage || ""
  });

  const citiesList = stateCityList[commonInput.state] || [];

  // Dynamic Fields
  const [leadDetails, setLeadDetails] = useState({});
  const [errors, setErrors] = useState({});

  // Dynamic Field Config
  const leadTypeFields = {
    loan_type_lead: [
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "natureOfBusienss", label: "Nature Of Busienss - Existing/ Proposed", type: "text" },
      { name: "sales", label: "Sales - Existing/ Proposed", type: "number" },
      { name: "statusOfBusiness", label: "Status Of Business", type: "dropdown", options: statusOfBusinessList },
      { name: "remarkTelecaller", label: "Remark Telecaller", type: "text" },
      { name: "whatIsYourCibilScore", label: "What Is Your Cibil Score", type: "dropdown", options: cibilScoreListData },
      { name: "typeOfCustomer", label: "Type Of Customer", type: "dropdown", options: TypeOfCustomerData },
      { name: "levelOfCustomer", label: "Level Of Customer", type: "dropdown", options: LevelOfCustomerData },
      // { name: "actionOnLead", label: "Action On Lead", type: "dropdown", options: ActionOnLeadData },
      { name: "nextFollowUpDate", label: "Next Follow Up Date", type: "date" },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },
    ],

    project_report_tev_study_pitch_deck: [
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "natureOfBusienssForProjectReport", label: "Nature Of Busienss For Project Report", type: "text" },
      { name: "remarkByTelecaller", label: "Remark By Telecaller", type: "text" },
      { name: "typeOfCustomer", label: "Type Of Customer", type: "dropdown", options: TypeOfCustomerData2 },
      { name: "levelOfCustomer/BusinessPartner", label: "Level Of Customer/ Business Partner", type: "dropdown", options: LevelOfCustomerData },
      // { name: "actionOnLead", label: "Action On Lead", type: "dropdown", options: ActionOnLeadData2 },
      { name: "nextFollowUpDate", label: "Next Follow Up Date", type: "date" },
      { name: "totalFeesAgreed", label: "Total Fees Agreed", type: "number" },
      { name: "advance", label: "Advance", type: "number" },
      { name: "advanceReceivedDate", label: "Advance Received Date", type: "date" },
      { name: "bankDetail", label: "Bank Detail", type: "dropdown", options: bankDetailsList },
      { name: "commitmentDate", label: "Commitment Date", type: "date" },
      { name: "finalDue", label: "Final Due", type: "number" },
      { name: "finalAmountRecdDate", label: "Final Amount Recd Date", type: "date" },
      { name: "bankAccount", label: "Bank Account", type: "number" },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },
    ],

    course: [
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "remarkTelecaller", label: "Remark Telecaller", type: "text" },
      { name: "telecallerAction", label: "Telecaller Action", type: "dropdown", options: TelecallerActionData },
      { name: "nextFollowUpDate", label: "Next Follow Up Date", type: "date" },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },

      // 👇 Conditional Fields
      {
        name: "dateOfPayment",
        label: "Date Of Payment Received",
        type: "date",
        showWhen: { field: "telecallerAction", value: "Success" },
      },
      {
        name: "amountOfPayment",
        label: "Amount Of Payment (In Lacs)",
        type: "number",
        showWhen: { field: "telecallerAction", value: "Success" },
      },
      {
        name: "bankAccount",
        label: "Bank Account",
        type: "number",
        showWhen: { field: "telecallerAction", value: "Success" },
      },
      {
        name: "onlineSalesUpload",
        label: "Upload From Online Sales",
        type: "file",
        showWhen: { field: "telecallerAction", value: "Success" },
      },
    ],

    software: [
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "remarkTelecaller", label: "Remark Telecaller", type: "text" },
      { name: "telecallerAction", label: "Telecaller Action", type: "dropdown", options: TelecallerActionData },
      { name: "nextFollowUpDate", label: "Next Follow Up Date", type: "date" },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },

      // 👇 Conditional Fields
      {
        name: "dateOfPayment",
        label: "Date Of Payment Received",
        type: "date",
        showWhen: { field: "telecallerAction", value: "Success" },
      },
      {
        name: "amountOfPayment",
        label: "Amount Of Payment (In Lacs)",
        type: "number",
        showWhen: { field: "telecallerAction", value: "Success" },
      },
      {
        name: "bankAccount",
        label: "Bank Account",
        type: "number",
        showWhen: { field: "telecallerAction", value: "Success" },
      },
      {
        name: "onlineSalesUpload",
        label: "Upload From Online Sales",
        type: "file",
        showWhen: { field: "telecallerAction", value: "Success" },
      },
    ],

    subsidy: [
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "remarkTelecaller", label: "Remark Telecaller", type: "text" },
      { name: "telecallerAction", label: "Telecaller Action", type: "dropdown", options: TelecallerActionData },
      { name: "nextFollowUpDate", label: "Next Follow Up Date", type: "date" },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },
    ],

    business_partner: [
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "background", label: "Background", type: "dropdown", options: BackgroundData },
      { name: "natureOfProductOrServicesInterested", label: "Nature Of Product Or Services Interested", type: "text" },
      { name: "remarkByPartner", label: "Remark By Partner", type: "text" },
      { name: "remarkByTelecaller", label: "Remark By Telecaller", type: "text" },
      { name: "statusOfBusinessPartner", label: "Status Of Business Partner", type: "dropdown", options: StatusOfBusinessPartnerData },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },
    ],

    customer_care_telecaller_any_other_query: [
      { name: "transferOfLead", label: "Transfer Of Lead", type: "text" },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },
    ],

    banker_directory: [
      { name: "designation", label: "Designation", type: "text", },
      { name: "levelOfDepartmentSalesLevelMinimum", label: "Level Of Department Sales Level Minimum", type: "number", },
      { name: "levelOfDepartmentSalesMaximum", label: "Level Of Department Sales Maximum", type: "number", },
      { name: "city", label: "City", type: "text", },
      { name: "bank/NbfcName/Fi,/Aif/Pe/Vc", label: "Bank/ Nbfc Name/ Fi,/ Aif/ Pe/ Vc", type: "dropdown", options: BankListData },
      { name: "loanProduct", label: "Loan Product", type: "text", },
      { name: "minimumLoanAmount", label: "Minimum Loan Amount (In Lacs)", type: "number", },
      { name: "maximumLoanAmount", label: "Maximum Loan Amount (In Lacs)", type: "number", },
      { name: "policyFeature", label: "Policy Feature", type: "text", },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },
    ],

    nivesh4u: [
      { name: "companyName", label: "Company Name", type: "text" },
      { name: "category", label: "Category", type: "dropdown", options: TypeOfCustomerData3 },
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "remarkByTelecaller", label: "Remark By Telecaller", type: "text" },
      { name: "natureOfService", label: "Nature Of Service", type: "dropdown", options: NatureOfServiceData },
      { name: "annualIncome", label: "Annual Income", type: "number" },
      { name: "proposedInvestment", label: "Proposed Investment", type: "number" },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },

    ],

    cfo_msme: [
      { name: "companyName", label: "Company Name", type: "text" },
      { name: "category", label: "Category", type: "dropdown", options: TypeOfCustomerData4 },
      { name: "emailId", label: "Email Id", type: "text" },
      { name: "natureOfService", label: "Nature Of Service", type: "dropdown", options: NatureOfServiceData2 },
      { name: "annualSaleProposedSale", label: "Annual Sale/ Proposed Sale", type: "text" },
      { name: "proposedFees ", label: "Proposed Fees", type: "number" },
      { name: "remarkTelecaller", label: "Remark Telecaller", type: "text" },
      { name: "leadStatus", label: "Lead Status", type: "dropdown", options: LeadStatus },
      { name: "reasonForNotDoable", label: "Reason For Not Doable", type: "text" },
    ],
  };

  // Reset dynamic fields when type changes
  useEffect(() => {
    setLeadDetails({});
    setErrors({});

    const leadStatusApiData = {
      leadTypeIn: [typeOfLead],
      roleIn: [],
      statusIn: [],
      activeOnly: ""
    };

    fetchLeadStatusApiData(leadStatusApiData)
  }, [typeOfLead]);

  const [leadStatusdata, setLeadStatusdata] = useState([])

  const fetchLeadStatusApiData = (data) => {

    getLeadStatusApi(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          setLeadStatusdata(newData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
  };

  useEffect(() => {
    if (rowData?.leadInfoList && rowData?.leadInfoList.length > 0) {

      let dynamicData = {};

      rowData.leadInfoList.forEach((item) => {

        if (item.keyType === "textType") {
          dynamicData[item.keyName] = item.textValue;
        }

        if (item.keyType === "doubleType") {
          dynamicData[item.keyName] = item.doubleValue;
        }

        if (item.keyType === "dateType") {
          dynamicData[item.keyName] = item.dateValue ? new Date(item.dateValue) : null;
        }

      });

      setLeadDetails(dynamicData);
    }
  }, [state]);

  const [userDataIds, setUserDataIds] = useState([])

  const userData = {
    searchBy: "",
    searchText: "",
    limit: 1000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    userTypeIdIn: [],
    roleIn: ["ROLE_TELECALLER"],
    statusIn: []

  };

  const getUsers = (userData) => {
    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const newDataId = newData.map(item => item.id);
          const newDataIds = newData.map(item => ({
            label: item.userName + " - " + item?.userTypeInfo, value: item.id
          }));

          setUserDataIds(newDataIds)

        }
      })
      .catch(() => {
        errorMessage();
      })
  }


  // Fetch dropdown data
  useEffect(() => {

    getUsers(userData)



    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
        }
      })
      .catch(() => errorMessage());

    // getLeadStatus()
    //   .then((response) => {
    //     if (!response.data.error) {
    //       const leadStatus = response.data.map((item) => ({
    //         label: item,
    //         value: item,
    //       }));
    //       setLeadStatusList(leadStatus);
    //     }
    //   })
    //   .catch(() => errorMessage());

    getLeadSource()
      .then((response) => {
        if (!response.data.error) {
          const leadSource = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadSourceList(leadSource);
        }
      })
      .catch(() => errorMessage());

    getBankAccount()
      .then((response) => {
        if (!response.data.error) {
          const leadSource = response.data.map((item) => ({
            label: item.name,
            value: item.name,
          }));
          setBankDetailsList(leadSource)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })


    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));

          setStateCitiesList(stateList)

          setStateCityList(Res)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));

    getPreferredLanguage()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setPreferredLanguageList(leadStatus);
        }
      })
      .catch(() => errorMessage());

  }, []);

  const totalFeesAgreed = Number(leadDetails.totalFeesAgreed) || 0;
  const advance = Number(leadDetails.advance) || 0;

  leadDetails.finalDue = totalFeesAgreed - advance;

  const validateForm = () => {
    let isValid = true;
    let newErrors = {};

    if (!typeOfLead) {
      newErrors.typeOfLead = "Please Select Type Of Lead";
      isValid = false;
    }

    if (!commonInput.name) {
      newErrors.name = "Please Enter Name";
      isValid = false;
    }

    if (!commonInput.mobileNo) {
      newErrors.mobileNo = "Please Enter Mobile No";
      isValid = false;
    }

    if (!commonInput.source) {
      newErrors.source = "Please Enter Source";
      isValid = false;
    }

    if (!commonInput.city) {
      newErrors.city = "Please Enter City";
      isValid = false;
    }

    if (!commonInput.pinCode) {
      newErrors.pinCode = "Please Enter Pin Code";
      isValid = false;
    }

    if (!commonInput.state) {
      newErrors.state = "Please Enter State";
      isValid = false;
    }

    if (!commonInput.loanAmount) {
      newErrors.loanAmount = "Please Enter Amount (In Lacs)";
      isValid = false;
    }

    if (!commonInput.address) {
      newErrors.address = "Please Select Address";
      isValid = false;
    }


    if (!commonInput.preferredLanguage) {
      newErrors.preferredLanguage = "Please Select Preferred Language";
      isValid = false;
    }

    leadTypeFields[typeOfLead]?.forEach((field) => {

      if (field.showWhen) {
        const dependentValue = leadDetails[field.showWhen.field];
        if (dependentValue !== field.showWhen.value) return;
      }

      if (!leadDetails[field.name]) {
        newErrors[field.name] = `Please Enter ${field.label}`;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    let leadInfoList = [];

    // Loop dynamic fields based on selected lead type
    leadTypeFields[typeOfLead]?.forEach((field) => {

      // Skip hidden conditional fields
      if (field.showWhen) {
        const dependentValue = leadDetails[field.showWhen.field];
        if (dependentValue !== field.showWhen.value) return;
      }

      const value = leadDetails[field.name];

      if (value === undefined || value === null || value === "") return;

      let leadInfoObj = {
        keyType: "",
        keyName: field.name,
        textValue: "",
        doubleValue: "",
        dateValue: ""
      };

      // Map field type to correct value column
      if (field.type === "text" || field.type === "dropdown") {
        leadInfoObj.keyType = "textType";
        leadInfoObj.textValue = value;
      }

      if (field.type === "number") {
        leadInfoObj.keyType = "doubleType";
        leadInfoObj.doubleValue = Number(value);
      }

      if (field.type === "date") {
        leadInfoObj.keyType = "dateType";
        leadInfoObj.dateValue = value;
      }

      leadInfoList.push(leadInfoObj);
    });

    const payload = {
      typeOfLead,
      ...commonInput,
      leadInfoList,
    };

    let data = {
      lead: {
        mobileNo: commonInput.mobileNo,
        name: commonInput.name,
        // status: commonInput.status,
        source: commonInput.source,
        city: commonInput.city,
        pinCode: commonInput.pinCode,
        state: commonInput.state,
        queries: commonInput.remarkCustomer,
        address: commonInput.address,
        amount: commonInput.loanAmount,
        typeOfLead: typeOfLead,
        preferredLanguage: commonInput.preferredLanguage
      },
      leadInfoList: leadInfoList,
    };

    let UserData = {
      lead: {
        mobileNo: commonInput.mobileNo,
        name: commonInput.name,
        // status: commonInput.status,
        source: commonInput.source,
        city: commonInput.city,
        pinCode: commonInput.pinCode,
        state: commonInput.state,
        queries: commonInput.remarkCustomer,
        address: commonInput.address,
        amount: commonInput.loanAmount,
        typeOfLead: typeOfLead,
        preferredLanguage: commonInput.preferredLanguage
      },
      leadInfoList: leadInfoList,
      user: {
        id: selectedTelecallerId
      }

    };


    let updateData = {
      lead: {
        id: rowData?.lead?.id,
        mobileNo: commonInput.mobileNo,
        name: commonInput.name,
        // status: commonInput.status,
        source: commonInput.source,
        city: commonInput.city,
        pinCode: commonInput.pinCode,
        state: commonInput.state,
        queries: commonInput.remarkCustomer,
        address: commonInput.address,
        amount: commonInput.loanAmount,
        typeOfLead: typeOfLead,
        preferredLanguage: commonInput.preferredLanguage
      },
      leadInfoList: leadInfoList,
    };

    let UpdateUserData = {
      lead: {
        id: rowData?.lead?.id,
        mobileNo: commonInput.mobileNo,
        name: commonInput.name,
        // status: commonInput.status,
        source: commonInput.source,
        city: commonInput.city,
        pinCode: commonInput.pinCode,
        state: commonInput.state,
        queries: commonInput.remarkCustomer,
        address: commonInput.address,
        amount: commonInput.loanAmount,
        typeOfLead: typeOfLead,
        preferredLanguage: commonInput.preferredLanguage
      },
      leadInfoList: leadInfoList,
      user: {
        id: selectedTelecallerId
      }

    };

    if (userProfileData.role === "ROLE_SUPER_TELECALLER") {
      if (rowData?.lead?.id) {

        updateLead(updateData)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                errorMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/super-telecaller-lead/list", {
                  state: {
                    listState: {
                      products,
                      first,
                      rows
                    }
                  }
                })
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          })
      } else {
        addUserLead(UserData)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                errorMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/super-telecaller-lead/list", {
                  state: {
                    listState: {
                      products,
                      first,
                      rows
                    }
                  }
                })
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          })
      }

    } else {

      if (rowData?.lead?.id) {
        updateLead(updateData)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                errorMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/super-telecaller-lead/list", {
                  state: {
                    listState: {
                      products,
                      first,
                      rows
                    }
                  }
                })
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          })
      } else {
        addLead(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                errorMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/super-telecaller-lead/list", {
                  state: {
                    listState: {
                      products,
                      first,
                      rows
                    }
                  }
                })
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          })
      }

    }





  };

  return (
    <main id="main" className="main">
      <section className="section">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title flex">
              <div
                className="mr-3 cursor-pointer"
                onClick={() =>
                  navigate("/super-telecaller-lead/list", {
                    state: {
                      listState: {
                        products,
                        first,
                        rows
                      }
                    }
                  })
                }
              >
                <i class="bi bi-arrow-left-circle-fill"></i>
              </div>
              Lead Form {state ? "Update" : "Create"}
            </h5>

            <form onSubmit={handleSubmit}>

              {/* Type Of Lead */}
              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">Type Of Lead</label>
                  <Dropdown
                    style={{ width: "100%" }}
                    options={leadTypeList}
                    value={typeOfLead}
                    onChange={(e) => setTypeOfLead(e.value)}
                  // disabled={state ? true : false}
                  />
                  <div className="text-danger">{errors.typeOfLead}</div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="source" className="form-label">
                    Source
                  </label>
                  <Dropdown
                    style={{ width: "100%" }}
                    options={leadSourceList}
                    value={commonInput.source}
                    onChange={(e) => {
                      setCommonInput({ ...commonInput, source: e.target.value })
                    }}
                  />
                  <div className="text-danger">{errors.source}</div>
                </div>
              </div>

              <div className="row mb-1">

                {!rowData?.lead?.id && <div className="col-md-12">

                  <label htmlFor="source" className="form-label">
                    Selected Telecaller
                  </label>
                  <Dropdown
                    style={{ width: "100%" }}
                    options={userDataIds}
                    value={selectedTelecallerId}
                    onChange={(e) => {
                      setSelectedTelecallerId(e.value);
                    }}
                  />
                </div>}

              </div>

              {/* Common Fields */}
              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">Name</label>
                  <InputText
                    style={{ width: "100%" }}
                    value={commonInput.name}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, name: e.target.value })
                    }
                  />
                  <div className="text-danger">{errors.name}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Mobile No</label>
                  <InputText
                    type="number"
                    style={{ width: "100%" }}
                    value={commonInput.mobileNo}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, mobileNo: e.target.value })
                    }
                  />
                  <div className="text-danger">{errors.mobileNo}</div>
                </div>
              </div>

              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">Amount (In Lacs){typeOfLead === "project_report_tev_study_pitch_deck" ? "(Project Cost)" : ""}</label>
                  <InputText
                    type="number"
                    style={{ width: "100%" }}
                    value={commonInput.loanAmount}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, loanAmount: e.target.value })
                    }
                    onWheel={(e) => e.target.blur()} // prevent mouse scroll
                    onKeyDown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault(); // prevent arrow increment/decrement
                      }
                    }}
                  />
                  <div className="text-danger">{errors.loanAmount}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">State</label>
                  <Dropdown
                    style={{ width: "100%" }}
                    value={commonInput.state}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, state: e.target.value })
                    }
                    options={stateCitiesList}
                    optionLabel="label"
                    placeholder="Select a State"
                    filter
                    filterDelay={400}
                  />
                  <div className="text-danger">{errors.state}</div>
                </div>


              </div>

              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">Pin Code </label>
                  <InputText
                    type="number"
                    style={{ width: "100%" }}
                    value={commonInput.pinCode}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, pinCode: e.target.value })
                    }
                    onWheel={(e) => e.target.blur()} // prevent mouse scroll
                    onKeyDown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault(); // prevent arrow increment/decrement
                      }
                    }}
                  />
                  <div className="text-danger">{errors.pinCode}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">City</label>
                  <Dropdown
                    style={{ width: "100%" }}
                    value={commonInput.city}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, city: e.target.value })
                    }
                    options={citiesList}

                    placeholder="Select a City"
                    filter
                    filterDelay={400}
                  />
                  <div className="text-danger">{errors.city}</div>
                </div>
              </div>



              <div className="row mb-1">
                <div className="col-md-6">
                  <label className="form-label">Address</label>
                  <InputText
                    style={{ width: "100%" }}
                    value={commonInput.address}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, address: e.target.value })
                    }
                  />
                  <div className="text-danger">{errors.address}</div>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Remark Customer</label>
                  <InputText
                    style={{ width: "100%" }}
                    value={commonInput.remarkCustomer}
                    onChange={(e) =>
                      setCommonInput({ ...commonInput, remarkCustomer: e.target.value })
                    }
                  />
                  <div className="text-danger">{errors.remarkCustomer}</div>
                </div>
              </div>

              <div className="row mb-1">

                <div className="col-md-6">
                  <label htmlFor="preferredLanguage" className="form-label">
                    Preferred Language
                  </label>
                  <Dropdown
                    style={{ width: "100%" }}
                    options={preferredLanguageList}
                    value={commonInput.preferredLanguage}
                    onChange={(e) => {
                      setCommonInput({ ...commonInput, preferredLanguage: e.target.value })
                    }}
                  />
                  <div className="text-danger">{errors.preferredLanguage}</div>
                </div>
              </div>

              {/* Dynamic Fields */}

              <div className="row">
                {leadTypeFields[typeOfLead]?.map((field, index) => {

                  // ✅ CONDITIONAL SHOW LOGIC
                  if (field.showWhen) {
                    const dependentValue = leadDetails[field.showWhen.field];
                    if (dependentValue !== field.showWhen.value) {
                      return null;
                    }
                  }

                  return (
                    <div className="col-md-6 mb-1" key={index}>
                      <label className="form-label">{field.label}</label>

                      {field.type === "text" && (
                        <InputText
                          style={{ width: "100%" }}
                          value={leadDetails[field.name] || ""}
                          onChange={(e) =>
                            setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.target.value,
                            })
                          }
                        />
                      )}

                      {field.type === "number" && (
                        <InputText
                          type="number"
                          style={{ width: "100%" }}
                          value={leadDetails[field.name] || ""}
                          onChange={(e) =>
                            setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.target.value,
                            })
                          }
                          onWheel={(e) => e.target.blur()} // prevent mouse scroll
                          onKeyDown={(e) => {
                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                              e.preventDefault(); // prevent arrow increment/decrement
                            }
                          }}
                        />
                      )}

                      {field.type === "date" && (
                        <div>
                          <Calendar id="buttondisplay"
                            value={leadDetails[field.name] || null}
                            onChange={(e) => setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.target.value,
                            })}
                            showIcon
                            dateFormat="dd/mm/yy"
                            minDate={minDate}
                            maxDate={maxDate}
                            style={{ width: "100%" }}
                          />
                        </div>

                      )}

                      {field.type === "dropdown" && (
                        <Dropdown
                          style={{ width: "100%" }}
                          options={field.options}
                          value={leadDetails[field.name] || ""}
                          onChange={(e) =>
                            setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.value,
                            })
                          }
                        />
                      )}

                      {field.type === "file" && (
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) =>
                            setLeadDetails({
                              ...leadDetails,
                              [field.name]: e.target.files[0],
                            })
                          }
                        />
                      )}

                      <div className="text-danger">{errors[field.name]}</div>
                    </div>
                  );
                })}
              </div>

              <div className="text-center">
                <button type="submit" className="move-btn move-btn-blue">
                  Submit
                </button>
              </div>

            </form>
          </div>
        </div>
      </section>
    </main>
  );
}